import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import { get } from "../services/ApiService";
import "./custom-style.css";

const MissingValue = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  // Get the type from query parameters
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type') || 'missing-values';
  
  // Map type to display names
  const typeNames = {
    'missing-customs-info': 'Customs Information missing for variations',
    'missing-dimensions': 'Product variation missing dimensions (length, width ,height)',
    'missing-format': 'Product Vairation missing format',
    'missing-service': 'Product missing postage service',
    'missing-weight': 'Product Variation missing weight',
    'missing-sql-variation': 'SQL database missing variations',
    'pmed-without-questions': 'P-Med Product without questions',

  };
  
  const displayName = typeNames[type] || 'Values';

  useEffect(() => {
    fetchData();
  }, [type]); // Re-fetch when type changes

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await get(`api/dashboard/missing-values?type=${type}`);
      if (res.success) {
        setData(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="row mb-4 align-items-center">
        <div className="col-sm-6 mb-3 mb-sm-0">
          <h2 className="fs-4 mb-0">Missing {displayName}</h2>
          <p className="text-muted mb-0">
            Products with incomplete {displayName.toLowerCase()}
          </p>
        </div>
        <div className="col-sm-6 d-flex flex-wrap justify-content-sm-end">
          <button 
            className="btn btn-primary btn-sm"
            onClick={fetchData}
            disabled={loading}
          >
            {loading ? 'Refreshing...' : 'Refresh Data'}
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
                  {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading missing {displayName.toLowerCase()} data...</p>
        </div>
      )}
      
      {!loading && data.length > 0 && (
        <>
          <div className="mb-3">
            <span className="badge bg-primary">
              {data.length} product{data.length !== 1 ? 's' : ''} found
            </span>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mb-4 rounded-4 p-7">
                <div className="card-body px-0 pt-7 pb-0">
                  <div className="table-responsive">
                    <table className="table table-hover align-middle table-nowrap mb-0 table-borderless">
                      <thead className="table-light">
                        <tr>
                          <th className="align-middle w-20" scope="col">SKU</th>
                          <th className="align-middle w-40" scope="col">Product</th>
                          <th className="align-middle w-20" scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item, index) => (
                          <tr key={index}>
                            {type === 'pmed-without-questions' ? (
                              <>
                                <td>{item.sku}</td>
                                <td><Link to={`/products/edit/${item?._id}`}>{item?.title}</Link></td>
                                <td>{item?.status}</td>
                              </>
                            ):(
<>
                            <td>{item.SKU}</td>
                            <td><Link to={`/products/edit/${item.product?._id}`}>{item.product?.title}</Link></td>
                            <td>{item.product?.status}</td>
</>
                            )}

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {!loading && data.length === 0 && (
        <div className="alert alert-info">
          No products with missing {displayName.toLowerCase()} found.
        </div>
      )}
      

        </div>
      </div>


    </Layout>
  );
};

export default MissingValue;